<template>
    <div class="discovery_wrap">
        <div class="root_div" style="border-radius: 4px">
            <div class="" style="border-radius: 8px">
                <v-form ref="deiscoverSeacrRef" @submit.prevent>
                    <div class="filterContainer" >
                        <v-text-field
                            class="ml-2 mr-2"
                            outlined
                            label="Start Month"
                            placeholder="mm-yyyy"
                            type="month"
                            style="width: 20%"
                            format="DD MMMM YYYY"
                            v-model="startMonth"
                            name="startMonthInput"
                            aria-required="true"
                            :min="minMonth"
                            :max="maxEndMonth"
                        />
                        <v-text-field
                            class="ml-2 mr-2"
                            label="End Month"
                            placeholder="mm-yyyy"
                            outlined
                            type="month"
                            style=" width: 20%"
                            v-model="endMonth"
                            :max="maxEndMonth"
                        />

                        <v-menu offset-y :close-on-content-click="showMenu">
                            <!-- <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    class="ml-2 mr-2 pa-0 state_seach"
                                    outlined
                                    label="Select State"
                                    style="margin-top: 2rem; width: 20%"
                                    placeholder="Select a state from the list"
                                    v-bind="attrs"
                                    v-on="on"
                                    v-model="stateName"
                                    :height="10"
                                    @click="showMenu = false"
                                    @focus="showMenu = false"
                                    :rules="appliedRules"
                                    icon="mdi-magnify"
                                />
                            </template> -->
                            <template v-slot:activator="{ on, attrs }">
                                <div
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="showMenu = false"
                                    @focus="showMenu = false"
                                    class="ml-2 mr-2 state_field flex"
                                >
                                    <small class="ml-2" style="font-size: 15px">{{ stateName }}</small>
                                    <v-spacer />
                                    <v-icon>mdi-menu-down</v-icon>
                                </div>
                            </template>

                            <!-- location filter  -->
                            <v-list style="box-shadow: none">
                                <v-card class="filter-con">
                                    <div>
                                        <div class="border_box">
                                            <div class="flex space-between mb-1" style="flex-wrap: wrap">
                                                <div class="grid_height flex mt-2" v-for="item in items" :key="item.id">
                                                    <div class="grid_tile flex">
                                                        <v-radio-group v-model="radioGroup" row>
                                                            <div class="flex">
                                                                <v-radio
                                                                    style="width: 14px"
                                                                    @click="
                                                                        stateName = capitalizeFirstLetter(item.eng_name)
                                                                    "
                                                                    :value="item.id"
                                                                    :label="capitalizeFirstLetter(item.eng_name)"
                                                                >
                                                                    <template v-slot:label>
                                                                        <p
                                                                            style="transform: translateY(7px)"
                                                                            class="text_radio"
                                                                            :value="item.id"
                                                                            @click="
                                                                                stateName = capitalizeFirstLetter(
                                                                                    item.eng_name
                                                                                )
                                                                            "
                                                                            :for="item.id"
                                                                        >
                                                                            {{ capitalizeFirstLetter(item.eng_name) }}
                                                                        </p>
                                                                    </template>
                                                                </v-radio>
                                                            </div>
                                                        </v-radio-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex filter-buttons">
                                        <button class="remove" @click="removeFilters">Clear</button>
                                        <button class="apply" @click="showMenu = true">Done</button>
                                    </div>
                                </v-card>
                            </v-list>
                        </v-menu>

                        <!-- entity search box  -->

                        <template>
                            <v-toolbar
                                dark
                                color="white"
                                class="ml-2 mr-2 search_box"
                                :outlined="true"
                                extension-height="25px"
                                flat
                                placeholder="Search terms here ?"
                                style="width: 20%"
                            >
                                <v-autocomplete
                                    v-model="model"
                                    :loading="isLoading"
                                    :items="searchitems"
                                    color="#919191"
                                    label="Search terms here?"
                                    flat
                                    :search-input.sync="search"
                                    chips
                                    :clearable="true"
                                    hide-details
                                    :hide-selected="true"
                                    item-text="name"
                                    item-value="symbol"
                                    solo-inverted
                                    no-filter
                                    @change="($event) => onChange($event, item)"
                                    no-data-text="No term found"
                                >
                                    <template v-slot:no-data>
                                        <v-list-item>
                                            <v-list-item-title> Search any term here </v-list-item-title>
                                        </v-list-item>
                                    </template>

                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.name"></v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-toolbar>
                        </template>

                        <button style="width: 20%" class="submit_btn white--text" @click="onSumbit">Submit</button>
                    </div>
                </v-form>
            </div>
        </div>
        <div class="mapcontainer flexbox mt-2">
            <!-- Map -->
            <custom-map ref="discoveryMap" @getBounds="setViewBoundsFromMap" />
            <!-- <div
                class="flex"
                style="background-color: #f1f6f4; border-radius: 4px"
            >
                <div style="background-color: #f1f6f4; width: 50%" class="flex">
                <small
                        style="
                            color: #328b37;
                            font-weight: 600;
                            font-size: 1rem;
                            padding: 0.4rem;
                        "
                        class="mt-0"
                        ><span style="color: #919191">Sample Size : </span>
                        4000</small
                    > 
                </div>
            </div> -->
        </div>
        <div class="flex grid_flex space-between mt-0">
            <div class="mt-0">
                <top-queries :data="obj" :click="isClicked" />
            </div>
            <div>
                <column-graph ref="columnGraphSearchRef" />
            </div>
        </div>
        <div class="flex grid_flex space-between mt-0">
            <div class="mt-0">
                <line-graph
                    heading="Crop Stage"
                    ref="cropStageLineGraph"
                    :click="isClicked"
                    :apiData="cropStageData"
                    filterText="Stage"
                />
            </div>
            <div>
                <line-graph
                    heading="Crop Disease"
                    ref="cropDiseaseLineGraph"
                    :click="isClicked"
                    :apiData="cropDiseaseData"
                    filterText="Disease"
                />
            </div>
        </div>
        <div class="flex grid_flex space-between mt-0">
            <div class="mt-0">
                <word-cloud :type="isCrop" :data="obj" :heading="cropHeading" :click="isClicked" />
            </div>

            <div>
                <word-cloud :type="isTopic" :data="obj" :heading="topicHeading" :click="isClicked" />
            </div>
        </div>
    </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import topQueries from "../DiscoverDashboard/components/top-queries.vue";
import columnGraph from "../DiscoverDashboard/components/column-graph.vue";
import wordCloud from "./components/wordcloud.vue";
import customMap from "../../MainDashboard/MyFarmers/components/gmap.vue";
import stateFilter from "./components/state-filters.vue";
import methods from "../../../helpers/methods";
import API_URL from "../../../helpers/apiUrls";
import rules from "../../../helpers/rules";
import gmap from "./components/gmap.vue";
import moment from "moment";
import lineGraph from "./components/line-graph.vue";
import { throws } from "assert";

export default {
    name: "discovery",
    components: {
        "top-queries": topQueries,
        "column-graph": columnGraph,
        "word-cloud": wordCloud,
        "state-filter": stateFilter,
        "custom-map": customMap,
        "line-graph": lineGraph,
    },
    created() {
        this.getStatesApiCall();
    },
    data() {
        return {
            zoom: 5,
            options: {
                center: {
                    lat: 28.9995601,
                    lng: 77.1395161,
                },
                mapTypeId: "roadmap",
            },
            items: null,
            showAgriForm: true,
            startMonth: methods.getDateRange(1, "months"),
            endMonth: methods.getDateRange(0, "months"),
            selectState: "",
            selectTerm: "",
            radioGroup: null,
            stateName: "Select State",
            showMenu: false,
            isCrop: "crop",
            isTopic: "topic",
            loading: false,
            items: [],
            search: null,
            select: null,
            isLoading: false,
            searchitems: [],
            model: null,
            search: null,
            tab: null,
            item: "",
            obj: {
                startMonth: "",
                endMonth: "",
                states: "",
                selectTerm: "",
            },
            cropHeading: "Crops WordCloud",
            topicHeading: "Topic WordCloud",
            isClicked: false,
            appliedRules: [],
            rules: rules,
            entityId: [],
            mapViewBounds: null,
            mapZoomLevel: 3,
            precision: 4,
            //mapZoomLevel: 1,
            minMonth: "2021-01",
            maxMonth: "",
            maxEndMonth: "",
            newRemovedterm: "",
            SelectedTermId: null,
            checkbox: true,
            cropStageData: [],
            cropDiseaseData: [],
            data: [
                {
                    name: "Workout",
                    data: {
                        "2017-01-01 00:00:00 -0800": 3,
                        "2017-01-02 00:00:00 -0800": 4,
                    },
                },
                {
                    name: "Call parents",
                    data: {
                        "2017-01-01 00:00:00 -0800": 5,
                        "2017-01-02 00:00:00 -0800": 3,
                    },
                },
            ],
        };
    },
    watch: {
        model(val) {
            if (val != null) this.tab = 0;
            else this.tab = null;
        },
        search(val) {
            this.isLoading = true;
            // if(this.selectTerm === ""){
            //     this.selectTerm = val
            // }

            console.log(val);
            this.getSearchedItem(val);
        },
        entityId: function (val) {
            console.log("item", val);
        },
    },
    computed: {},
    mounted() {
        setTimeout(() => {
            console.log(
                "this.$refs.discoveryMap.getViewBounds()",
                this.$refs.discoveryMap.getViewBounds(),
                this.$refs.discoveryMap.zoom
            );
            this.mapViewBounds = this.$refs.discoveryMap.getViewBounds();

            //this.$refs.discoveryMap.setHeatMap();
        }, 1000);

        this.getCurrMonth();
        console.log("DISC MOUNTED");
    },
    methods: {
        capitalizeFirstLetter(string) {
            var str = string.toLowerCase();
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        getCurrMonth() {
            console.log("HERE");
            const date = new Date();
            var prevmonth = date.getMonth();

            const tempMonth = "2022-0" + `${prevmonth}`;
            // console.log("TEMP MONTH", tempMonth);
            this.maxMonth = tempMonth;
            this.maxEndMonth = moment(date).format("YYYY-MM");
            // console.log("MONTH", this.endMonth);
        },
        setViewBoundsFromMap(payload, zoom) {
            // const getzoom = this.evaluatePrecision(zoom);
            console.log("payload", payload, zoom);
            if (this.stateName == "" || this.stateName == "Select State") {
                this.showToast("Please Select State", "success", 4000);
                return;
            }
            const location = this.getMapLocation(payload, zoom);
            console.log("llllll", location, payload);
            //this.$refs.discoveryMap.addMarkers(location);
        },
        getMapLocation(payload, zoom) {
            console.log("payload====>", payload);
            this.toggleLoader(true);
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log("getMapLocation", response.data);
                    if (response.data.length > 0) {
                        this.$refs.discoveryMap.center = response.data[0].location;
                    }
                    this.$refs.discoveryMap.addMarkers(response.data);

                    setTimeout(() => {
                        this.toggleLoader(false);
                    }, 2000);
                }
            };

            const errorHandler = (error) => {
                this.showToast("Something went wrong internally!", "error", 10000);
                console.log(error);
                this.toggleLoader(false);
            };
            const data =
                this.entityId == null || this.entityId.length < 1
                    ? {
                          start_month: this.startMonth,
                          end_month: this.endMonth,
                          precision: zoom <= 10 ? 3 : zoom - 6,

                          states: [this.radioGroup],
                          view_bounds: payload,
                      }
                    : {
                          start_month: this.startMonth,
                          end_month: this.endMonth,
                          precision: zoom <= 6 ? 3 : zoom - 4,
                          entity_ids: this.entityId,
                          states: [this.radioGroup],
                          view_bounds: payload,
                      };
            this.newRequestPOST(
                `${API_URL.getUser_LatLng}`,
                data,
                {},
                successHandler,
                errorHandler,
                process.env.VUE_APP_API_BASE_URL_DISCOVERY
            );
            console.log("data===>", data);
            //return  followersData;
        },
        onChange(val) {
            this.entityId = [];
            if (val == null) {
                this.entityId = [];
                console.log("CHANGE ITEM", val);
                this.selectTerm = "";
            } else {
                this.searchitems.map((item) => {
                    console.log(item);
                    this.entityId.push(item.id);
                    if (item.name == val) {
                        this.SelectedTermId = item.id;
                        console.log("SelectedTermId", this.SelectedTermId);
                    }
                });
                this.selectTerm = val;
            }
            console.log("SELECTED ", this.selectTerm);
            this.newRemovedterm = this.selectTerm.replace(/ *\([^)]*\) */g, "");
            console.log(this.newRemovedterm);
        },
        getSearchedItem(query) {
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.isLoading = false;
                    this.searchitems = response.data;
                    console.log("searchitems", this.searchitems);
                }
            };

            const errorHandler = (error) => {
                if (error.response.status === 404) {
                    console.log(error);
                } else {
                    this.showToast("Something went wrong internally!", "error", 10000);
                }

                console.log(error);
                this.isLoading = false;
            };

            this.requestGET(
                `${API_URL.getEntityResult}?q=${query}`,
                {},
                {},
                successHandler,
                errorHandler,
                process.env.VUE_APP_API_BASE_URL_ENTITY_SEARCH
            );
        },
        // process.env.VUE_APP_API_BASE_URL_ENTITY_SEARCH

        querySelections(v) {
            this.loading = true;
            setTimeout(() => {
                this.items = this.states.filter((e) => {
                    return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
                });
                this.loading = false;
            }, 500);
        },
        checkState() {},

        onSumbit() {
            if (this.stateName == "" || this.stateName == "Select State") {
                this.showToast("Please Select State", "success", 4000);
                return;
            }

            this.appliedRules.push(this.rules.required);
            this.setViewBoundsFromMap(this.mapViewBounds, this.mapZoomLevel);
            if (this.$refs.deiscoverSeacrRef.validate()) {
                this.$refs.discoveryMap.zoom = this.zoom;
                console.log(typeof this.startMonth);

                console.log("val", this.startMonth, this.endMonth, this.radioGroup, this.selectTerm);

                this.isClicked = !this.isClicked;

                // send this object to worldcloud component as props
                let arr = [];
                arr.push(this.radioGroup);
                console.log("ARRAY", arr);

                (this.obj.startMonth = this.startMonth),
                    (this.obj.endMonth = this.endMonth),
                    (this.obj.states = arr),
                    (this.obj.selectTerm = this.selectTerm);

              
                if (this.SelectedTermId != null) {
                    this.getCropStageApiCall();
                    this.getCropDiseaseApiCall();
                    this.getUserSearchTextData();
                }
            }
        },
        removeFilters() {
            this.radioGroup = null;
            this.stateName = "";
            this.showMenu = true;
            this.stateName = "Select State";
            this.states = [];
        },

        getStatesApiCall() {
            this.toggleLoader(true);
            const successHandler = (response) => {
                this.toggleLoader(false);

                if (response.status === 200) {
                    console.log("states ", response.data);
                    this.items = response.data.results;
                }
            };

            const errorHandler = (error) => {
                this.showToast("Something went wrong internally!", "error", 10000);
                console.log(error);

                this.toggleLoader(false);
            };

            this.requestGET(`${API_URL.getStates}`, {}, {}, successHandler, errorHandler);
        },

        getUserSearchTextData() {
            console.log("TERM", this.selectTerm);
            var term = this.newRemovedterm.toLowerCase();
            this.$refs.columnGraphSearchRef.loader = true;
            this.toggleLoader(true);
            const successHandler = (response) => {
                this.toggleLoader(false);

                if (response.status === 200) {
                    console.log("res ", response.data);
                    this.$refs.columnGraphSearchRef.searchTextData = response.data.user_search;
                }
            };

            const errorHandler = (error) => {
                this.showToast("Something went wrong internally!", "error", 10000);
                console.log(error);
                this.$refs.columnGraphSearchRef.loader = false;
                this.toggleLoader(false);
            };
            this.requestGET(
                `${API_URL.getUser_search}?start_month=${this.startMonth}&end_month=${this.endMonth}&search_query=${term}`,
                {},
                {},
                successHandler,
                errorHandler,
                process.env.VUE_APP_API_BASE_URL_DISCOVERY,
                300000
            );
        },
        getCropStageApiCall() {
            console.log("TERM", this.selectTerm);
            var term = this.newRemovedterm.toLowerCase();
            this.$refs.cropStageLineGraph.isClicked = true;
            this.$refs.cropStageLineGraph.loader = true;
            this.$refs.cropStageLineGraph.items = [];
            this.toggleLoader(true);
            const successHandler = (response) => {
                this.toggleLoader(false);

                if (response.status === 200) {
                    console.log("Crop Stage", response.data);
                    this.cropStageData = response.data;

                    this.$refs.cropStageLineGraph.loader = false;
                }
            };

            const data = {
                start_month: this.startMonth,
                end_month: this.endMonth,
                states: [this.radioGroup],
                entity_ids: [this.SelectedTermId],
            };

            const errorHandler = (error) => {
                this.showToast("Something went wrong internally!", "error", 10000);
                console.log(error);
                this.$refs.cropStageLineGraph.loader = false;
                this.toggleLoader(false);
            };
            this.newRequestPOST(
                `${API_URL.getCropStage}`,
                data,
                {},
                successHandler,
                errorHandler,
                process.env.VUE_APP_API_BASE_URL_DISCOVERY,
                300000
            );
        },
        getCropDiseaseApiCall() {
            console.log("TERM", this.selectTerm);
            var term = this.newRemovedterm.toLowerCase();
            this.$refs.cropDiseaseLineGraph.isClicked = true;
            this.$refs.cropDiseaseLineGraph.loader = true;
            this.$refs.cropDiseaseLineGraph.items = [];
            this.toggleLoader(true);
            const successHandler = (response) => {
                this.toggleLoader(false);

                if (response.status === 200) {
                    console.log("Crop Stage", response.data);
                    this.cropDiseaseData = response.data;
                    this.$refs.cropDiseaseLineGraph.loader = false;
                }
            };

            const data = {
                start_month: this.startMonth,
                end_month: this.endMonth,
                states: [this.radioGroup],
                entity_ids: [this.SelectedTermId],
            };

            const errorHandler = (error) => {
                this.showToast("Something went wrong internally!", "error", 10000);
                console.log(error);
                this.$refs.cropDiseaseLineGraph.loader = false;
                this.toggleLoader(false);
            };
            this.newRequestPOST(
                `${API_URL.getCropDisease}`,
                data,
                {},
                successHandler,
                errorHandler,
                process.env.VUE_APP_API_BASE_URL_DISCOVERY,
                300000
            );
        },
    },
};
</script>

<style scoped>
.filterContainer{
    display: flex;
    align-items: flex-start;
    padding: 25px 0px 20px;
}
.root_div {
    background-color: #fbfbfb;
}
#map {
    width: 100%;
    z-index: -1;
    margin: 0, 0, 0, 0;
    height: 400px;
}
.state_field {
    width: 20%;
    border-radius: 4px;
    border: 1.2px solid #b9b0b0 !important;
    height: 56.5px;
    padding: 1.2px;
}

.submit_btn {
    margin-right: 1rem;
    height: 56px;
    border-radius: 3px;
    width: 18%;
    background-color: #308434;
    padding: 0.4rem;
}
.mapcontainer {
    border-radius: 8px;
    position: relative;
    z-index: 2;
    width: 100%;
    height: 400px;
    margin-bottom: 0rem;
    margin-top: 0.8rem;
    background-color: #fbfbfb;
    border-radius: 8px;
    margin-bottom: 8px;
}
.grid_flex > div:nth-child(1) {
    width: 50%;
}

.grid_flex > div:nth-child(2) {
    width: 49%;
}
.filter-con {
    border-radius: 12px;
    padding: 30px;
    width: 420px;
    padding: auto;
}

.custom-text-field.v-text-field.v-text-field--enclosed .v-input__slot {
    padding: 0;
}
.v-input__slot {
    padding: 0px;
}
.grid_height {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0px;
    background-color: white;
    width: 48.7%;
    justify-content: left;
    height: 27px;
    border-radius: 2px;
}
.v-tooltip__content {
    background-color: #308434;
    color: #fbfbfb;
    /* background: #D8D8D8; */
    border: 0.6px solid #308434;
    border-radius: 5px;
    max-width: 250px;
    min-width: 200px;
    text-align: center;
    font-size: 13px;
    padding: 10px 12px;
    font-weight: 500;
}

/* .text_radio {
    width: 100px;
    white-space: nowrap;
    justify-content: flex-start;
    text-overflow: ellipsis;
    overflow: hidden;
    transform: translateY(-4px);
    cursor: pointer;
} */
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
.border_box {
    border: 0.5px solid #bfbfbf !important;
    height: 240px;
    border-radius: 8px;
    margin-bottom: 1rem;
    overflow: hidden;
    overflow-y: scroll;
    padding-left: 18px;
}
.text_radio {
    width: 120px;
    white-space: nowrap;
    justify-content: flex-start;
    text-overflow: ellipsis;
    overflow: hidden;
    transform: translateY(7px);
    cursor: pointer;
}
.remove {
    background-color: rgba(57, 186, 123, 0.11);
    width: 50%;
    color: #328736;
}
.apply {
    background-color: #36983b;
    width: 50%;
    color: #fff;
}
.filter-buttons > button {
    width: 100%;
    column-gap: 20px;
}
.mdi-clear {
    color: #308434;
}
.filter-buttons > button {
    padding: 15px 20px;
    border-radius: 5px;
    font-size: 0.8rem;
    font-weight: 500;
    margin: 4px;
}
</style>

<style>
.v-toolbar__content {
    border: 1.5px solid #70707091 !important;
    border-radius: 3px !important;
    height: 56px !important;
    margin-top: 0rem !important;
    padding: 3px 0px !important;
}
.theme--dark.v-label {
    color: rgba(0, 0, 0, 0.57);
}

.theme--dark.v-chip:not(.v-chip--active) {
    background-color: #a2a1a1;
    /* color: #9E9F9E; */
}
.v-application--is-ltr .v-text-field .v-input__append-inner {
    padding-left: 0px;
}
.v-chip .v-chip__content {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-flex;
    height: 100%;
    max-width: 100%;
}
.theme--dark.v-chip {
    background-color: #a2a1a1;
    /* color: #9E9F9E; */
}
.theme--dark.v-icon {
    color: #a2a1a1;
}
.state_seach.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0px;
    padding-left: 8px;
}
</style>

<style>
/* .custom-text-field .v-text-field.v-text-field--enclosed .v-input__slot {
  padding: 0px !important;
} */
.state_seach.v-input input {
    max-height: 100px;
}
.state_seach.v-text-field input {
    line-height: 40px;
}
.state_seach.v-input input::placeholder {
    margin-left: 20px;
}
.state_seach.v-text-field input::placeholder {
    line-height: 40px;
    margin-left: 10px;
}
.state_seach.v-input .v-label {
    margin-left: 6px;
}
.filterContainer .v-messages{
    display: none !important; 
}
.filterContainer .v-text-field.v-text-field--enclosed .v-text-field__details{
        display: none !important; 

}
</style>
